<template>
  <div>
    <v-main>
      <!-- <h1>Friend Get Friend</h1> -->
      <div style=" overflow-y: hidden;overflow-x: hidden;padding:0px 12px">
        <!-- class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4" -->
        <v-row style="padding:1% 2% 0%; height: 80px;">
          <v-col xs="12" sm="12" md="12" lg="12" style="padding-bottom:0">
            <h2>Friend Get Friend</h2>
          </v-col>
        </v-row>
        <v-divider style="padding-top:0; magin: 0px 0px"></v-divider>
        <v-row>
          <v-col>
            <v-tabs v-model="tab" color="#1b437c">
              <v-tab>
                <h4>สมัครสมาชิก</h4>
              </v-tab>
              <!-- <v-tab>
                                <h4>ใช้งานในระบบ</h4>
                            </v-tab> -->
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item style="padding:15px 15px">
                <v-card flat>
                  <v-row>
                    <v-col>
                      <v-switch
                        v-model="statusUpA.statusUpdateA"
                        class="mt-0"
                        color="green lighten-2"
                        hide-details
                        label="สถานะการใช้งาน"
                        @click="updateStatusA()"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-spacer v-if="resCol !== '12'"></v-spacer>
                    <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                      <div>
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-row>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px 15px;justify-content: center; align-items: center;display: flex;"
                            >
                              <v-card
                                @click="chooseImage"
                                class="image-input"
                                :style="{
                                  'background-image': `url(${formupdateA.pictureUrlPreviewA})`,
                                  'background-size': 'contain',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat'
                                }"
                              >
                                <span
                                  v-if="formupdateA.pictureUrlPreviewA === ''"
                                  class="placeholder"
                                  style="justify-content: center; align-items: center;display: flex;"
                                  >Choose an Image</span
                                >
                                <input
                                  style="display: none"
                                  class="file-input"
                                  ref="fileInputA"
                                  type="file"
                                  @input="onSelectFile"
                                />
                              </v-card>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px"
                            >
                              <v-text-field
                                v-model="formupdateA.massageA"
                                label="ข้อความเชิญเพื่อน"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:12px 15px 0px"
                            >
                              <p style="margin: 0px 0px">
                                เงื่อนไขการได้รับรางวัลของสมาชิก
                              </p>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px"
                            >
                              <v-radio-group v-model="formupdateA.con_memA" row>
                                <v-radio
                                  label="สมัครสมาชิก"
                                  value="สมัครสมาชิก"
                                  color="#6683d3"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:12px 15px 0px"
                            >
                              <p style="margin: 0px 0px">
                                จำกัดการเชิญของผู้แนะนำ
                              </p>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px"
                            >
                              <v-radio-group
                                v-model="formupdateA.limit_addA"
                                row
                              >
                                <v-radio
                                  label="ไม่จำกัดจำนวน"
                                  value="ไม่จำกัดจำนวน"
                                  color="#6683d3"
                                ></v-radio>
                                <v-radio
                                  label="จำกัดจำนวน"
                                  value="จำกัดจำนวน"
                                  color="#6683d3"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px"
                              v-if="formupdateA.limit_addA === 'จำกัดจำนวน'"
                            >
                              <v-text-field
                                v-model="formupdateA.count_memA"
                                label="จำกัดจำนวน"
                                type="number"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px"
                            >
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model="formupdateA.point_inviterA"
                                    label="คะแนนสำหรับผู้แนะนำ"
                                    type="number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model="formupdateA.point_invitee_getsA"
                                    label="คะแนนสำหรับผู้ถูกเชิญ"
                                    type="number"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px 25px"
                            >
                              <v-btn block color="primary" @click="updateA"
                                >บันทึก</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-form>
                      </div>
                    </v-col>
                    <v-spacer v-if="resCol !== '12'"></v-spacer>
                  </v-row>
                </v-card>
              </v-tab-item>
              <!-- <v-tab-item style="padding:15px 15px">
                                <v-card flat>
                                    <v-row>
                                        <v-col>
                                            <v-switch
                                                v-model="statusUpB.statusUpdateB"
                                                class="mt-0"
                                                color="green lighten-2"
                                                hide-details
                                                label="สถานะการใช้งาน"
                                                @click="updateStatusB()"
                                            ></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-spacer v-if="resCol !== '12'"></v-spacer>
                                        <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                                            <div>
                                                <v-form ref="form" v-model="valid" lazy-validation>
                                                    <v-row>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:0px 10px 15px;justify-content: center; align-items: center;display: flex;"
                                                        >
                                                            <v-card
                                                                @click="chooseImageB"
                                                                class="image-input"
                                                                :style="{
                              'background-image': `url(${formupdateB.pictureUrlPreviewB})`,
                              'background-size': 'contain',
                              'background-position': 'center center',
                              'background-repeat': 'no-repeat'
                            }"
                                                            >
                                                                <span
                                                                    v-if="formupdateB.pictureUrlPreviewB === ''"
                                                                    class="placeholder"
                                                                    style="justify-content: center; align-items: center;display: flex;"
                                                                >Choose an Image</span>
                                                                <input
                                                                    style="display: none"
                                                                    class="file-input"
                                                                    ref="fileInputB"
                                                                    type="file"
                                                                    @input="onSelectFileB"
                                                                />
                                                            </v-card>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:0px 10px"
                                                        >
                                                            <v-text-field
                                                                v-model="formupdateB.massageB"
                                                                label="ข้อความเชิญเพื่อน"
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:12px 15px 0px"
                                                        >
                                                            <p style="margin: 0px 0px">เงื่อนไขการได้รับรางวัลของสมาชิก</p>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:0px 10px"
                                                        >
                                                            <v-radio-group v-model="formupdateB.con_memB" row>
                                                                <v-radio
                                                                    label="ใช้งานระบบ"
                                                                    value="ใช้งานระบบ"
                                                                    color="#6683d3"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:12px 15px 0px"
                                                        >
                                                            <p style="margin: 0px 0px">จำกัดการเชิญของผู้แนะนำ</p>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:0px 10px"
                                                        >
                                                            <v-radio-group v-model="formupdateB.limit_addB" row>
                                                                <v-radio
                                                                    label="ไม่จำกัดจำนวน"
                                                                    value="ไม่จำกัดจำนวน"
                                                                    color="#6683d3"
                                                                ></v-radio>
                                                                <v-radio
                                                                    label="จำกัดจำนวน"
                                                                    value="จำกัดจำนวน"
                                                                    color="#6683d3"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:0px 10px"
                                                            v-if="formupdateB.limit_addB === 'จำกัดจำนวน'"
                                                        >
                                                            <v-text-field
                                                                v-model="formupdateB.count_memB"
                                                                label="จำกัดจำนวน"
                                                                type="number"
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:0px 10px"
                                                        >
                                                            <v-row>
                                                                <v-col cols="6">
                                                                    <v-text-field
                                                                        v-model="formupdateB.point_inviterB"
                                                                        label="คะแนนสำหรับผู้แนะนำ"
                                                                        type="number"
                                                                        outlined
                                                                        dense
                                                                    ></v-text-field>
                                                                </v-col>
                                                                <v-col cols="6">
                                                                    <v-text-field
                                                                        v-model="formupdateB.point_invitee_getsB"
                                                                        label="คะแนนสำหรับผู้แนะนำผู้ถูกเชิญ"
                                                                        type="number"
                                                                        outlined
                                                                        dense
                                                                    ></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                        <v-col
                                                            cols="12"
                                                            xs="12"
                                                            sm="12"
                                                            md="12"
                                                            lg="12"
                                                            style="padding:0px 10px 25px"
                                                        >
                                                            <v-btn block color="primary" @click="updateB">บันทึก</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-form>
                                            </div>
                                        </v-col>
                                        <v-spacer v-if="resCol !== '12'"></v-spacer>
                                    </v-row>
                                </v-card>
                            </v-tab-item> -->
            </v-tabs-items>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
export default {
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      tab: null,
      session: this.$session.getAll(),
      path: '/FriendGetFriend/',
      returnLink: '/System/FriendGetFriend',
      valid: true,
      filesAdd: null,
      filesAddB: null,
      statusUpA: {
        statusUpdateA: ''
      },
      statusUpB: {
        statusUpdateB: ''
      },
      formupdateA: {
        pictureA: '',
        massageA: '',
        con_memA: 'สมัครสมาชิก',
        limit_addA: 'ไม่จำกัดจำนวน',
        count_memA: 0,
        point_inviterA: '',
        point_invitee_getsA: '',
        pictureUrlPreviewA: '',
        LAST_USER: ''
      },
      formupdateB: {
        pictureB: '',
        massageB: '',
        con_memB: 'ใช้งานระบบ',
        limit_addB: 'ไม่จำกัดจำนวน',
        count_memB: 0,
        point_inviterB: '',
        point_invitee_getsB: '',
        pictureUrlPreviewB: '',
        LAST_USER: ''
      },
      ID: ''
    }
  },

  async mounted () {
    this.getData()
    console.log()
  },
  methods: {
    updateStatusB () {
      axios
        .post(this.DNS_IP + `/FriendGetFriend/edit/${this.ID}`, this.statusUpB)
        .then(res => {
          if (res.data.status === true) {
            this.$swal({
              title: 'อัพเดทสถานะ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
          }
        })
    },
    updateStatusA () {
      console.log('A', this.statusUpdateA)
      axios
        .post(this.DNS_IP + `/FriendGetFriend/edit/${this.ID}`, this.statusUpA)
        .then(res => {
          if (res.data.status === true) {
            this.$swal({
              title: 'อัพเดทสถานะ',
              text: 'สำเร็จ',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
          }
        })
    },
    chooseImage () {
      this.$refs.fileInputA.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInputA
      this.filesAdd = input.files
      if (this.filesAdd) {
        console.log('เข้า')
        this.formupdateA.pictureUrlPreviewA = URL.createObjectURL(
          this.filesAdd[0]
        )
      } else {
        this.formupdateA.pictureUrlPreviewA = ''
      }
      this.$forceUpdate()
      console.log('kkkk', this.formAdd.pictureUrlPreview)
    },
    chooseImageB () {
      this.$refs.fileInputB.click()
    },
    onSelectFileB () {
      const input = this.$refs.fileInputB
      this.filesAddB = input.files
      if (this.filesAddB) {
        console.log('เข้า')
        this.formupdateB.pictureUrlPreviewB = URL.createObjectURL(
          this.filesAddB[0]
        )
      } else {
        this.formupdateB.pictureUrlPreviewB = ''
      }
      this.$forceUpdate()
      console.log('kkkk', this.formAdd.pictureUrlPreview)
    },
    validate () {
      this.$refs.form.validate()
    },
    async submitA () {
      console.log('fileAdd', this.filesAdd)
      //   if (this.$refs.form.validate() === true) {
      this.formAdd.CREATE_USER = this.session.data.userName
      this.formAdd.LAST_USER = this.session.data.userName
      //   console.log('aa')
      const _this = this
      let params = new FormData()
      params.append('file', this.filesAdd[0])
      console.log('file', params.append('file', this.filesAdd[0]))
      if (this.filesAdd) {
        await axios
          .post(this.DNS_IP + `/file/upload/blog`, params)
          .then(function (response) {
            console.log('aa')
            _this.formAdd.pictureA = response.data
            console.log('url Pic', response.data)
          })
        delete this.formAdd['pictureUrlPreviewA']
      }
      console.log(this.DNS_IP + '/FriendGetFriend/add')
      if (this.formAdd.count_memA === '') {
        this.formAdd.count_memA = 0
      }
      await axios
        .post(this.DNS_IP + '/FriendGetFriend/add', this.formAdd)
        .then(res => {
          console.log('addDataGlobal DNS_IP + PATH + "add"', res)

          this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
        })
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          //   this.dataReady = true
        })
      //   }
    },
    async getData () {
      await axios
        .get(
          this.DNS_IP +
            '/FriendGetFriend/get?shopId=' +
            this.session.data.shopId
        )
        .then(result => {
          let rs = result.data[0]
          if (result.data) {
            this.ID = rs.id
            // console.log(ID)
            // this.formupdateA.id = rs.id
            if (rs.statusUpdateA === 'true' || rs.statusUpdateA === 'True') {
              this.statusUpA.statusUpdateA = true
            } else if (
              rs.statusUpdateA === 'false' ||
              rs.statusUpdateA === 'False'
            ) {
              this.statusUpA.statusUpdateA = false
            }
            // this.formupdateA.statusUpdateA = rs.statusUpdateA
            // this.filesAdd = rs.pictureA
            this.formupdateA.pictureA = rs.pictureA
            this.formupdateA.pictureUrlPreviewA = rs.pictureA
            this.formupdateA.massageA = rs.massageA
            this.formupdateA.con_memA = rs.con_memA
            this.formupdateA.limit_addA = rs.limit_addA
            this.formupdateA.count_memA = rs.count_memA
            this.formupdateA.point_inviterA = rs.point_inviterA
            this.formupdateA.point_invitee_getsA = rs.point_invitee_getsA
            // this.formupdateA.id = rs.id
            if (rs.statusUpdateB === 'true' || rs.statusUpdateB === 'True') {
              this.statusUpB.statusUpdateB = true
            } else if (
              rs.statusUpdateB === 'false' ||
              rs.statusUpdateB === 'False'
            ) {
              this.statusUpB.statusUpdateB = false
            }
            this.formupdateB.pictureB = rs.pictureB
            this.formupdateB.pictureUrlPreviewB = rs.pictureB
            this.formupdateB.massageB = rs.massageB
            this.formupdateB.con_memB = rs.con_memB
            this.formupdateB.limit_addB = rs.limit_addB
            this.formupdateB.count_memB = rs.count_memB
            this.formupdateB.point_inviterB = rs.point_inviterB
            this.formupdateB.point_invitee_getsB = rs.point_invitee_getsB
          }
          console.log('result', result.data)
        })
    },
    async updateA () {
      //   alert('ssss')
      this.formupdateA.LAST_USER = this.session.data.userName

      if (this.filesAdd) {
        const _this = this
        let params = new FormData()
        params.append('file', this.filesAdd[0])
        console.log('file', this.filesAdd)
        // alert('if')
        await axios
          .post(this.DNS_IP + `/file/upload/blog`, params)
          .then(function (response) {
            console.log('aa')
            _this.formupdateA.pictureA = response.data
            console.log('url Pic', response.data)
          })
      } else {
        // alert('else')
        this.formupdateA.pictureA = this.formupdateA.pictureUrlPreviewA
      }
      delete this.formupdateA['pictureUrlPreviewA']

      await axios
        .post(
          this.DNS_IP + `/FriendGetFriend/edit/${this.ID}`,
          this.formupdateA
        )
        .then(response => {
          console.log('555')
          if (response.data.status === true) {
            this.$swal({
              title: 'เรียบร้อย',
              type: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ตกลง'
            })
              .then(async result => {
                console.log(result)
                this.getData()
                // this.$router.push('/System/friendgetfriend')
                // location.reload()
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            this.$swal('ผิดพลาด', response.data.message, 'error')
            this.$router.push('/Tool/CollectQRCode')
            location.reload()
          }
        })
    },
    async updateB () {
      //   delete this.formAdd['pictureUrlPreviewB']
      this.formupdateB.LAST_USER = this.session.data.userName

      if (this.filesAddB) {
        const _this = this
        let params = new FormData()
        params.append('file', this.filesAddB[0])
        console.log('file', params.append('file', this.filesAddB[0]))
        await axios
          .post(this.DNS_IP + `/file/upload/blog`, params)
          .then(function (response) {
            console.log('aa')
            _this.formupdateB.pictureB = response.data
            console.log('url Pic', response.data)
          })
      } else {
        this.formupdateB.pictureB = this.formupdateB.pictureUrlPreviewB
      }
      delete this.formupdateB['pictureUrlPreviewB']
      await axios
        .post(
          this.DNS_IP + `/FriendGetFriend/edit/${this.ID}`,
          this.formupdateB
        )
        .then(response => {
          console.log('555')
          if (response.data.status === true) {
            this.$swal({
              title: 'เรียบร้อย',
              type: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ตกลง'
            })
              .then(async result => {
                console.log(result)
                this.getData()
                // this.$router.push('/System/friendgetfriend')
                // location.reload()
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            this.$swal('ผิดพลาด', response.data.message, 'error')
            this.$router.push('/Tool/CollectQRCode')
            location.reload()
          }
        })
    },
    updateswit1 () {},
    updateswit2 () {}
  }
}
</script>
<style scope>
.image-input {
  display: block;
  width: 230px;
  height: 230px;
  /* min-width: 300px;
  min-height: 300px; */
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
@media screen and (min-width: 320px) {
  /* smartphones, iPhone, portrait 480x320 phones */
  div .div1 {
    width: 100%;
    height: 180px;
    /* display: flex;
      align-items: center;
      justify-content: center; */
  }
  div h3 {
    font-size: 16px !important;
  }
  h2.text-h {
    /* font-family: 'Poppins'; */
    font-style: normal;
    font-weight: 600;
    font-size: 24px !important;
    line-height: 160%;
    color: #667085;
  }
}

@media screen and (min-width: 481px) {
  /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
  div h3 {
    font-size: 14px !important;
  }
}
@media screen and (min-width: 641px) {
  /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
}
@media screen and (min-width: 961px) {
  /* tablet, landscape iPad, lo-res laptops ands desktops */
}
@media screen and (min-width: 1025px) {
  /* big landscape tablets, laptops, and desktops */
}
@media screen and (min-width: 1281px) {
  /* hi-res laptops and desktops */
}
</style>



// WEBPACK FOOTER //
// src/components/System/Friendgetfriend.vue